import { isCustomView } from './is-custom-view';
export function isSetterConfig(obj) {
  return obj && typeof obj === 'object' && 'componentName' in obj && !isCustomView(obj);
}